<template>
  <div class="insert_local">
    <div class="upload_local_pic">
      <el-upload :action="actionUrl"
                 ref="eluploadimg"
                 multiple
                 :limit="limitImgLength"
                 :file-list="fileListDefault"
                 list-type="picture-card"
                 :headers='uploadHeaders'
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :on-exceed="handleExceed"
                 :on-remove="handleRemove"
                 :before-upload='beforeupload'>
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>

  </div>
</template>

<script>
export default {
  name: 'fromLocal',
  components: {

  },
  data() {
    return {
      fileListDefault: [],
      imgList: [],
      limitImgLength: 3,
    }
  },
  props: {
    choiceUrlList: {
      type: Array,
      required: true
    },
    maxImgLength: {
      type: Number,
      required: true
    },
    orgUrlList: {
      type: Array,
      required: true
    }
  },
  computed: {
    actionUrl() {
      return _API_ + 'api/article/editor/header_image_uploader?token=' + this.$store.state.userinfo.token
    },
    uploadHeaders() {
      var option = {
        token: this.$store.state.userinfo.token
      }
      return option
    }
  },
  methods: {
    clearData() {
      this.$refs.eluploadimg.clearFiles();
      this.fileListDefault = []
    },

    handleExceed() {
      toastr.warning('上传文件数不能超出头图限定范围！')
    },

    handleSuccess(response, file, fileList) {
      console.log(this)
      if (response) {
        try {
          let url = response.data[0]
          if (url) {
            this.$emit('choiceCancleImg', url)

          }

        } catch (e) {
          console.error(e)
        }
      }
    },

    handleError(err, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: '图片上传失败'
      });
    },

    handleRemove(file) {
      if (!file) return
      let url = ''
      try {
        url = file.response.data[0]
      } catch (e) {
        console.log('can\'t find url!')
      }
      this.$emit('choiceCancleImg', url)
    },

    beforeupload(file) {
      if (this.choiceUrlList.length >= (this.maxImgLength - this.orgUrlList.length)) {
        this.$notify.warning({
          title: '错误',
          message: '头图总数已达到三张'
        });
        return false
      } else {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isJPGS = file.type === 'image/jpg';
        const isLtFiveM = file.size / 1024 / 1024 < 5
        if (!isJPG && !isGIF && !isPNG && !isBMP && !isJPGS) {
          this.$notify.error({
            title: '错误',
            message: '图片格式不正确'
          });
        }
        if (!isLtFiveM) {
          this.$notify.error({
            title: '错误',
            message: '上传头图大小不能超过 5MB!'
          });
        }
        return ((isJPG || isBMP || isGIF || isPNG || isJPGS) && isLtFiveM)
      }
    },

  },
}
</script>

<style lang='stylus' scoped>
.insert_local
  all-length()
  box-sizing border-box
  padding 20px

  .upload_local_pic
    overflow auto
    height 100%
</style>
